<template>
  <div>
    <v-row>
      <v-col cols="12 py-0">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col>
                <!-- Filters -->
                <v-row class="ma-0 align-right sub-section">
                  <TableFilters
                    :filters="[
                      'saleType',
                      'search',
                      'dateRange',
                      'paymentStatus',
                      'shop',
                    ]"
                    v-model="filter"
                    :columns="columns"
                    :msgs="'Shop'"
                  ></TableFilters>
                  <ImportExportMenu></ImportExportMenu>
                </v-row>
                <!-- Data table -->
                <v-row>
                  <v-col cols="12" class="textbold">
                    <v-data-table
                      :items-per-page="paginationOptions.perPage"
                      :headers="headers"
                      :items="payment"
                      :search="search"
                      @click:row="$router.push(`/sales/view/${$event.id}`)"
                      class="row-pointer"
                      hide-default-footer
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      style="font-weight: bold"
                    >
                      <template v-slot:no-data>
                        <div class="mt-16 container justify-center item-center">
                          <img
                            style="height: 200px"
                            src="../../../assets/img/no-result.jpg"
                          />
                        </div>
                      </template>

                      <template slot="body.footer">
                        <tr class="black--text" v-if="total > 0">
                          <th class="title"></th>
                          <th class="title"></th>

                          <th>
                            <h3>{{ totalSales | formatCurrency }}</h3>
                          </th>
                          <th class="text-center">
                            <h3>{{ discountAmount | formatCurrency }}</h3>
                          </th>
                          <th class="text-center">
                            <h3>{{ total | formatCurrency }}</h3>
                          </th>
                          <th class="text-right">
                            <h3></h3>
                          </th>
                        </tr>
                      </template>
                      <template v-slot:item.status="{ item }">
                        <v-chip
                          :x-small="true"
                          class="ma-2"
                          label
                          text-color="white"
                          :color="GetPaymentStatusColor(item.status)"
                          dark
                          >{{ item.status }}</v-chip
                        >
                      </template>
                      <template v-slot:item.shop.name="{ item }">
                        {{
                          ShopView == 'name'
                            ? item.shop.name
                            : item.shop.sortform
                        }}
                      </template>
                      <template v-slot:item.user="{ item }">
                        {{ item.user ? item.user.first_name : '' }}
                      </template>
                      <template v-slot:item.date="{ item }">{{
                        item.date | formatDate
                      }}</template>

                      <template v-slot:item.amount="{ item }">
                        <strong class="px-4">{{
                          item.amount | formatCurrency
                        }}</strong></template
                      >

                      <template v-slot:footer="{}">
                        <paginationComponent
                          @paginationOptions="setPaginationOptions"
                          :url="'customers/' + customerId + '/sales'"
                          :filter="filter"
                          :paginationAction="false"
                          @response="receivePurchaseResponse"
                        />
                      </template>
                      <template
                        slot="body.append"
                        v-if="PaymentList && PaymentList.length > 0"
                      >
                      </template> </v-data-table
                  ></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <!-- </v-container> -->
  </div>
</template>

<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->
<script>
import datePickComponent from '../../../components/base/DateComponent.vue';

import paginationComponent from '../../shared/components/pagination.vue';
import TableFilters from '@/components/base/TableFilters';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      paginationOptions: {},
      PaymentList: [],
      loading: true,
      search: '',
      total: 0,
      totalSales: 0,
      discountAmount: 0,
      columns: [
        {
          text: 'Date',
          value: 'date',
          show: true,
          disabled: false,
        },
        {
          text: 'Shop',
          value: 'shop.name',
          show: true,
          disabled: false,
        },
        {
          text: 'Total ',
          value: 'grand_total',
          show: true,
          align: 'left',
          disabled: false,
        },

        {
          text: 'Discount ',
          value: 'discount_amount',
          align: 'center',
          show: true,
          disabled: false,
        },
        {
          text: 'Paid',
          value: 'paid_amount',
          align: 'center',
          show: true,
          disabled: false,
        },
        {
          text: ' Type',
          value: 'sale_type',
          align: 'center',
          show: true,
          disabled: false,
        },
        {
          text: 'Biller',
          value: 'biller.first_name',
          align: 'center',
          show: true,
          disabled: false,
        },

        {
          text: 'Status',
          value: 'status',
          show: true,
          disabled: false,
        },
      ],
      payment: [],
      filter: {
        paymentType: '',
        start: '',
        end: '',
        paymentStatus: '',
      },
      date_range: [],
      GetPaymentStatusColor(status) {
        switch (status) {
          case 'Cancelled':
            return 'red';
            break;
          case 'Pending':
            return 'orange';
            break;
          case 'Partially Paid':
            return 'orange';
            break;
          case 'Completed':
            return 'green';
            break;
          default:
            break;
        }
      },
    };
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    receivePurchaseResponse(payment) {
      this.payment = payment;

      this.total = this.sumField(this.payment, 'paid_amount');
      this.totalSales = this.sumField(this.payment, 'grand_total');
      this.discountAmount = this.sumField(this.payment, 'discount_amount');
      this.loading = false;
    },
    clearFilter() {
      this.filter = {};
    },
    SetSuplierId() {
      this.customerId = this.$route.params.id;
    },
    startDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    GetAllPayments() {
      this.$store
        .dispatch('purchase/AddPayment', 1)
        .then((res) => {
          self.siteSetting = res.data;

          this.Supplier.addresses.forEach((address) => {
            address.country_id = self.siteSetting.country.id;
          });
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },
  },

  mounted() {},

  components: {
    datePickComponent,
    paginationComponent,
    TableFilters,
  },
  created() {
    this.SetSuplierId();
  },

  computed: {
    ...mapState(['ShopView']),

    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(' ~ ');
    },
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>

<style scoped>
.textbold {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
</style>
